import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as actionsTypesMembers from '../actionsTypesMembers'

function souscripteurRequest(isLoading) {
  return {
    type: actionsTypesMembers.SOUSCRIPTEUR_REQUEST,
    isLoading,
  }
}
function souscripteurFailure(isError) {
  return {
    type: actionsTypesMembers.SOUSCRIPTEUR_FAILURE,
    isError,
  }
}
function souscripteurSuccess(isSuccess, souscripteurData) {
  return {
    type: actionsTypesMembers.SOUSCRIPTEUR_SUCCESS,
    isSuccess,
    souscripteurData,
  }
}
export function fetchSouscripteurAction(souscripteurID) {
  return function(dispatch, getState) {

    dispatch(souscripteurRequest(true))

    return backendMembers.getSouscripteur(souscripteurID)
      .then(souscripteurData => {
        dispatch(souscripteurRequest(false))
        dispatch(souscripteurSuccess(true, souscripteurData))
      })
      .catch(error => {
        dispatch(souscripteurRequest(false))
        dispatch(souscripteurFailure(true))
      })
  }
}

function addSouscripteurRequest(isLoading) {
  return {
    type: actionsTypesMembers.ADD_SOUSCRIPTEUR_REQUEST,
    isLoading,
  }
}
function addSouscripteurFailure(isError) {
  return {
    type: actionsTypesMembers.ADD_SOUSCRIPTEUR_FAILURE,
    isError,
  }
}
function addSouscripteurSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.ADD_SOUSCRIPTEUR_SUCCESS,
    isSuccess
  }
}
export function fetchAddSouscripteurAction(isCurrentLoginCourtier, userID, souscripteurData) {
  return function(dispatch, getState) {

    dispatch(addSouscripteurRequest(true))

    return backendMembers.saveSouscripteur(isCurrentLoginCourtier, userID, souscripteurData)
      .then(response => {
        let isCurrentLoginCourtier = localStorage.getItem("isCurrentLoginCourtier")
        if(isCurrentLoginCourtier) {
          localStorage.setItem('souscripteurID', response._id)
        }
        
        dispatch(addSouscripteurRequest(false))
        dispatch(addSouscripteurSuccess(true))
      })
      .catch(error => {
        dispatch(addSouscripteurRequest(false))
        dispatch(addSouscripteurFailure(true))
      })
  }
}

function updateSouscripteurRequest(isLoading) {
  return {
    type: actionsTypesMembers.UPDATE_SOUSCRIPTEUR_REQUEST,
    isLoading,
  }
}
function updateSouscripteurFailure(isError) {
  return {
    type: actionsTypesMembers.UPDATE_SOUSCRIPTEUR_FAILURE,
    isError,
  }
}
function updateSouscripteurSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.UPDATE_SOUSCRIPTEUR_SUCCESS,
    isSuccess
  }
}
export function fetchUpdateSouscripteurAction(souscripteurID, souscripteurData) {
  return function(dispatch, getState) {

    dispatch(updateSouscripteurRequest(true))

    return backendMembers.updateSouscripteur(souscripteurID, souscripteurData)
      .then(response => {
        dispatch(updateSouscripteurRequest(false))
        dispatch(updateSouscripteurSuccess(true))
      })
      .catch(error => {
        dispatch(updateSouscripteurRequest(false))
        dispatch(updateSouscripteurFailure(true))
      })
  }
}

function sendMailSouscripteurRequest(isLoading) {
  return {
    type: actionsTypesMembers.SEND_MAIL_SOUSCRIPTEUR_REQUEST,
    isLoading,
  }
}
function sendMailSouscripteurFailure(isError) {
  return {
    type: actionsTypesMembers.SEND_MAIL_SOUSCRIPTEUR_FAILURE,
    isError,
  }
}
function sendMailSouscripteurSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.SEND_MAIL_SOUSCRIPTEUR_SUCCESS,
    isSuccess
  }
}
export function fetchSendMailSouscripteurAction(emailData) {
  return function(dispatch, getState) {

    dispatch(sendMailSouscripteurRequest(true))

    return backendMembers.sendEmail(emailData)
      .then(response => {
        dispatch(sendMailSouscripteurRequest(false))
        dispatch(sendMailSouscripteurSuccess(true))
      })
      .catch(error => {
        dispatch(sendMailSouscripteurRequest(false))
        dispatch(sendMailSouscripteurFailure(true))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Souscription/Souscripteur.js